<template>

    <div class="frame" :style="{'--sinkbox-plank-scale': framePlankScale, '--actions-offset-x': actionsOffset.x, '--actions-offset-z': actionsOffset.z, '--actions-offset-y': actionsOffset.y, transform:rotation}" :class="[{'is-current-group': this.isCurrentGroup, 'has-shadow': this.showShadow, 'is-flipped': this.isFlipped}, sinkBoxClass]">


        <div class="structure" >
            <Module @click.native.prevent.stop="handleFrameClick" :showMeasure="true" class="frame_module" :moduleID="moduleID" ref="frame" :item="group" :settings="group.settings"/>
        </div>

        <Actions class="actions" remove="true" move="true" flip="true" draghandle="drag-handle-frame"  @flip="flipFrame" @moveleft="MOVE_GROUP({old:index, new:-1})" @moveright="MOVE_GROUP({old:index, new:+1})" @remove="REMOVE_GROUP({index})"/>

    </div>

</template>

<script>
import Module from '@/components/Module'
import Actions from '@/components/Actions'
import {mapActions, mapGetters} from 'vuex'
export default {

  name: 'Sideboard',

  props:['group', 'index', 'moduleID', 'showShadow', 'canSelect', 'angle'],

  data: function(){
      
    return {
        observer : null,
        isFlipped: false,
        moduleCount : null
    }
  },

  methods:{

        ...mapActions(['EDIT_ITEM', 'MOVE_GROUP', 'REMOVE_GROUP', 'UPDATE_SETTING']),

        handleFrameClick(){
            if(this.canSelect){
                this.EDIT_ITEM({item:this.group, path:[this.index]});
            }
        },

        handleModuleMove(){
           
        },

        flipFrame(){
            this.isFlipped = !this.isFlipped;
        }
  },

  computed:{

      ...mapGetters(['selectedItem', 'stageSettings']),

      factor(){
      
        return this.stageSettings.stage_scale;
    },

      size(){
          if(this.group.hasOwnProperty('items')){
              console.log(this.group.items.length);
              return this.group.items.length;
          }else{
              return 1;
          }
      },

      isCurrentGroup(){
          return this.group === this.selectedItem;
      },

      actionsOffset(){
        return {y: 2 * this.factor + 'px', x:  this.group.settings.sideboard_size * this.factor + 'px', z: 10 * this.factor + 'px'}
      },

      rotation(){
        switch(this.angle){
            case 'side': 
                return 'rotateY(-90deg)';
            case 'back': 
                return 'rotateY(-180deg)';
            case 'front': 
                return 'rotateY(0deg)';
        }
    },

      sinkBoxClass(){
        
        if(this.sinkPos > -1){
            return 'has-sinkbox-at-' + this.sinkPos;
        }

        if(this.gasPos > -1){
            return 'has-sinkbox-last'
        }

        return 'has-no-sinkbox';
      },

      sinkPos(){
          if(!this.group.items) return;
          return this.group.items.map(function(x) {return x.id; }).lastIndexOf('kitchen_sink');
      },

      gasPos(){
           if(!this.group.items) return;
        return this.group.items.map(function(x) {return x.id; }).lastIndexOf('gas_grill');
      },

      framePlankScale(){
        return `${Math.ceil(0.6 * this.factor)}em`;
    }

  },

  mounted(){

    var self = this;

    //this.moduleCount = this.size;

    // Create the observer (and what to do on changes...)
    // this.observer = new MutationObserver(function(mutations) {        
    //    var frameSize = self.$el.querySelectorAll('.module.top').length;
    //     self.$refs.frame.setSize(frameSize);
    // }.bind(this));

    // Setup the observer
    // this.observer.observe(
    //   self.$el.querySelector('.modules'),
    //   { attributes: true, childList: true, characterData: true, subtree: true }
    // );

    },

   beforeDestroy: function() {
    // Clean up observer
    //this.observer.disconnect();
  },

  components:{
      Module,
      Actions
  }

}
</script>


<style scoped>
    :root{
        --sinkpos_0: 1em; 
        
    }
    .sinkbox{
        z-index:9;
    }
    .sinkbox{
        transition:300ms;
    }

    .frame_module{
        background-size: calc(1em * var(--background-scale)) 100%;
    }

    .has-sinkbox-last .sinkbox{
        right:80px!important;
        left:auto;
    }

    .has-sinkbox-at-0 .sinkbox{
        left:4.5em!important;
    }

    .has-sinkbox-at-1 .sinkbox{
        left:13em!important;
    }

    .has-sinkbox-at-2 .sinkbox{
        left:23em!important;
    }

    .has-no-sinkbox .sinkbox{
        display: none!important;
        left:0!important;
    }



</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.frame{
    display:inline-block;
    transform-style: preserve-3d;
    text-align:center;
    position: relative;
    vertical-align:bottom;
   
    /* //transform:rotateX(-85deg); */
}

.frame.has-shadow::after{
    display:block;
    content:'';
    left:0px;
    right:0px;
    bottom:0;
    top:auto;
    height:200px;
    position: absolute;
    transform:rotateX(90deg) translateZ(-100px) translateY(100px);
    background:linear-gradient(transparent 0%, rgba(0,0,0,0.03) 50%, transparent 70%),radial-gradient(ellipse at top left, rgba(0,0,0,0.06) 0%,  transparent 70%,transparent 100%), 
    radial-gradient(ellipse at top right, rgba(0,0,0,0.3) 0%,  transparent 70%,transparent 100%);
    pointer-events:none;
}

.show-gaps .frame{
    margin:0 15px;
}

.show-measure .frame{
    margin:0 50px;
}
.frame.is-flipped .structure, .frame.is-flipped .modules{
    transform:rotateY(180deg);
    transform-style: preserve-3d;
}

.actions{
   transform: translateX(var(--actions-offset-x)) translateZ(var(--actions-offset-z)) translateY(-100px) ;
    display: none;
    position: absolute;
    left:50%;
    margin-left:-100px;
}

.is-current-group .actions{
    display: block;
}

.modules{
    z-index:3;
    position:relative;
    transform-style: preserve-3d;    
    transition:300ms;
}

.structure{
    position:relative;
    z-index:1;
    transform-style: preserve-3d;  
    transition:300ms;  
}

.structure .frame_module{ 
    display:block;
}

/* .frame.is-current-group{
    transform:translateY(-10px);
    
} */


</style>
